import { render, staticRenderFns } from "./ViewTeamDetail.vue?vue&type=template&id=726d7c9a"
import script from "./ViewTeamDetail.vue?vue&type=script&lang=js"
export * from "./ViewTeamDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports